/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HealthFindrBaseService } from '../health-findr-base-service';
import { HealthFindrApiConfiguration } from '../health-findr-api-configuration';
import { HealthFindrStrictHttpResponse } from '../health-findr-strict-http-response';

import { apiAdminApiTestsGet } from '../fn/admin/api-admin-api-tests-get';
import { ApiAdminApiTestsGet$Params } from '../fn/admin/api-admin-api-tests-get';
import { apiAdminApiTestsIdDelete } from '../fn/admin/api-admin-api-tests-id-delete';
import { ApiAdminApiTestsIdDelete$Params } from '../fn/admin/api-admin-api-tests-id-delete';
import { apiAdminApiTestsIdFailuresGet } from '../fn/admin/api-admin-api-tests-id-failures-get';
import { ApiAdminApiTestsIdFailuresGet$Params } from '../fn/admin/api-admin-api-tests-id-failures-get';
import { apiAdminApiTestsIdRerunPost } from '../fn/admin/api-admin-api-tests-id-rerun-post';
import { ApiAdminApiTestsIdRerunPost$Params } from '../fn/admin/api-admin-api-tests-id-rerun-post';
import { apiAdminApiTestsIdStopPost } from '../fn/admin/api-admin-api-tests-id-stop-post';
import { ApiAdminApiTestsIdStopPost$Params } from '../fn/admin/api-admin-api-tests-id-stop-post';
import { apiAdminApiTestsRunPost } from '../fn/admin/api-admin-api-tests-run-post';
import { ApiAdminApiTestsRunPost$Params } from '../fn/admin/api-admin-api-tests-run-post';
import { apiAdminFhirIdHealthCareServicesGet } from '../fn/admin/api-admin-fhir-id-health-care-services-get';
import { ApiAdminFhirIdHealthCareServicesGet$Params } from '../fn/admin/api-admin-fhir-id-health-care-services-get';
import { apiAdminFhirIdParentOrganizationSpecialitiesGet } from '../fn/admin/api-admin-fhir-id-parent-organization-specialities-get';
import { ApiAdminFhirIdParentOrganizationSpecialitiesGet$Params } from '../fn/admin/api-admin-fhir-id-parent-organization-specialities-get';
import { apiAdminFhirIdSpecialitiesGet } from '../fn/admin/api-admin-fhir-id-specialities-get';
import { ApiAdminFhirIdSpecialitiesGet$Params } from '../fn/admin/api-admin-fhir-id-specialities-get';
import { apiAdminLocationsSpecialitiesHealthCareServiceFhirIdGet } from '../fn/admin/api-admin-locations-specialities-health-care-service-fhir-id-get';
import { ApiAdminLocationsSpecialitiesHealthCareServiceFhirIdGet$Params } from '../fn/admin/api-admin-locations-specialities-health-care-service-fhir-id-get';
import { apiAdminOrganizationsGet } from '../fn/admin/api-admin-organizations-get';
import { ApiAdminOrganizationsGet$Params } from '../fn/admin/api-admin-organizations-get';
import { apiAdminPractitionerIdPasswordResetPost } from '../fn/admin/api-admin-practitioner-id-password-reset-post';
import { ApiAdminPractitionerIdPasswordResetPost$Params } from '../fn/admin/api-admin-practitioner-id-password-reset-post';
import { apiAdminSystemSpecialityGroupsGet } from '../fn/admin/api-admin-system-speciality-groups-get';
import { ApiAdminSystemSpecialityGroupsGet$Params } from '../fn/admin/api-admin-system-speciality-groups-get';
import { apiAdminSystemSpecialityGroupsIdDelete } from '../fn/admin/api-admin-system-speciality-groups-id-delete';
import { ApiAdminSystemSpecialityGroupsIdDelete$Params } from '../fn/admin/api-admin-system-speciality-groups-id-delete';
import { apiAdminSystemSpecialityGroupsIdGet } from '../fn/admin/api-admin-system-speciality-groups-id-get';
import { ApiAdminSystemSpecialityGroupsIdGet$Params } from '../fn/admin/api-admin-system-speciality-groups-id-get';
import { apiAdminSystemSpecialityGroupsIdMappingsPost } from '../fn/admin/api-admin-system-speciality-groups-id-mappings-post';
import { ApiAdminSystemSpecialityGroupsIdMappingsPost$Params } from '../fn/admin/api-admin-system-speciality-groups-id-mappings-post';
import { apiAdminSystemSpecialityGroupsIdPut } from '../fn/admin/api-admin-system-speciality-groups-id-put';
import { ApiAdminSystemSpecialityGroupsIdPut$Params } from '../fn/admin/api-admin-system-speciality-groups-id-put';
import { apiAdminSystemSpecialityGroupsPost } from '../fn/admin/api-admin-system-speciality-groups-post';
import { ApiAdminSystemSpecialityGroupsPost$Params } from '../fn/admin/api-admin-system-speciality-groups-post';
import { EntityMetadataModel } from '../models/entity-metadata-model';
import { HealthCareServiceMetadataModel } from '../models/health-care-service-metadata-model';
import { KeyValueModel } from '../models/key-value-model';
import { OrganizationMetadataModel } from '../models/organization-metadata-model';
import { SystemSpecialityGroupViewModel } from '../models/system-speciality-group-view-model';
import { TestFailure } from '../models/test-failure';
import { TestRunSummaryViewModel } from '../models/test-run-summary-view-model';

@Injectable({ providedIn: 'root' })
export class HealthFindrAdminService extends HealthFindrBaseService {
  constructor(config: HealthFindrApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAdminApiTestsRunPost()` */
  static readonly ApiAdminApiTestsRunPostPath = '/api/Admin/ApiTests/Run';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminApiTestsRunPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminApiTestsRunPost$Response(params?: ApiAdminApiTestsRunPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<void>> {
    return apiAdminApiTestsRunPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminApiTestsRunPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminApiTestsRunPost(params?: ApiAdminApiTestsRunPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAdminApiTestsRunPost$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAdminApiTestsIdRerunPost()` */
  static readonly ApiAdminApiTestsIdRerunPostPath = '/api/Admin/ApiTests/{id}/Rerun';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminApiTestsIdRerunPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminApiTestsIdRerunPost$Response(params: ApiAdminApiTestsIdRerunPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<void>> {
    return apiAdminApiTestsIdRerunPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminApiTestsIdRerunPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminApiTestsIdRerunPost(params: ApiAdminApiTestsIdRerunPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAdminApiTestsIdRerunPost$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAdminApiTestsIdStopPost()` */
  static readonly ApiAdminApiTestsIdStopPostPath = '/api/Admin/ApiTests/{id}/Stop';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminApiTestsIdStopPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminApiTestsIdStopPost$Response(params: ApiAdminApiTestsIdStopPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<void>> {
    return apiAdminApiTestsIdStopPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminApiTestsIdStopPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminApiTestsIdStopPost(params: ApiAdminApiTestsIdStopPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAdminApiTestsIdStopPost$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAdminApiTestsIdDelete()` */
  static readonly ApiAdminApiTestsIdDeletePath = '/api/Admin/ApiTests/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminApiTestsIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminApiTestsIdDelete$Response(params: ApiAdminApiTestsIdDelete$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<void>> {
    return apiAdminApiTestsIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminApiTestsIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminApiTestsIdDelete(params: ApiAdminApiTestsIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.apiAdminApiTestsIdDelete$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAdminApiTestsGet()` */
  static readonly ApiAdminApiTestsGetPath = '/api/Admin/ApiTests';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminApiTestsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminApiTestsGet$Response(params?: ApiAdminApiTestsGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<TestRunSummaryViewModel>>> {
    return apiAdminApiTestsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminApiTestsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminApiTestsGet(params?: ApiAdminApiTestsGet$Params, context?: HttpContext): Observable<Array<TestRunSummaryViewModel>> {
    return this.apiAdminApiTestsGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<Array<TestRunSummaryViewModel>>): Array<TestRunSummaryViewModel> => r.body)
    );
  }

  /** Path part for operation `apiAdminApiTestsIdFailuresGet()` */
  static readonly ApiAdminApiTestsIdFailuresGetPath = '/api/Admin/ApiTests/{id}/Failures';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminApiTestsIdFailuresGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminApiTestsIdFailuresGet$Response(params: ApiAdminApiTestsIdFailuresGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<TestFailure>>> {
    return apiAdminApiTestsIdFailuresGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminApiTestsIdFailuresGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminApiTestsIdFailuresGet(params: ApiAdminApiTestsIdFailuresGet$Params, context?: HttpContext): Observable<Array<TestFailure>> {
    return this.apiAdminApiTestsIdFailuresGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<Array<TestFailure>>): Array<TestFailure> => r.body)
    );
  }

  /** Path part for operation `apiAdminOrganizationsGet()` */
  static readonly ApiAdminOrganizationsGetPath = '/api/Admin/Organizations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminOrganizationsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminOrganizationsGet$Response(params?: ApiAdminOrganizationsGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<OrganizationMetadataModel>>> {
    return apiAdminOrganizationsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminOrganizationsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminOrganizationsGet(params?: ApiAdminOrganizationsGet$Params, context?: HttpContext): Observable<Array<OrganizationMetadataModel>> {
    return this.apiAdminOrganizationsGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<Array<OrganizationMetadataModel>>): Array<OrganizationMetadataModel> => r.body)
    );
  }

  /** Path part for operation `apiAdminFhirIdHealthCareServicesGet()` */
  static readonly ApiAdminFhirIdHealthCareServicesGetPath = '/api/Admin/{fhirId}/HealthCareServices';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminFhirIdHealthCareServicesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminFhirIdHealthCareServicesGet$Response(params: ApiAdminFhirIdHealthCareServicesGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<EntityMetadataModel>>> {
    return apiAdminFhirIdHealthCareServicesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminFhirIdHealthCareServicesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminFhirIdHealthCareServicesGet(params: ApiAdminFhirIdHealthCareServicesGet$Params, context?: HttpContext): Observable<Array<EntityMetadataModel>> {
    return this.apiAdminFhirIdHealthCareServicesGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<Array<EntityMetadataModel>>): Array<EntityMetadataModel> => r.body)
    );
  }

  /** Path part for operation `apiAdminLocationsSpecialitiesHealthCareServiceFhirIdGet()` */
  static readonly ApiAdminLocationsSpecialitiesHealthCareServiceFhirIdGetPath = '/api/Admin/LocationsSpecialities/{healthCareServiceFhirId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminLocationsSpecialitiesHealthCareServiceFhirIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminLocationsSpecialitiesHealthCareServiceFhirIdGet$Response(params: ApiAdminLocationsSpecialitiesHealthCareServiceFhirIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<HealthCareServiceMetadataModel>> {
    return apiAdminLocationsSpecialitiesHealthCareServiceFhirIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminLocationsSpecialitiesHealthCareServiceFhirIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminLocationsSpecialitiesHealthCareServiceFhirIdGet(params: ApiAdminLocationsSpecialitiesHealthCareServiceFhirIdGet$Params, context?: HttpContext): Observable<HealthCareServiceMetadataModel> {
    return this.apiAdminLocationsSpecialitiesHealthCareServiceFhirIdGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<HealthCareServiceMetadataModel>): HealthCareServiceMetadataModel => r.body)
    );
  }

  /** Path part for operation `apiAdminFhirIdSpecialitiesGet()` */
  static readonly ApiAdminFhirIdSpecialitiesGetPath = '/api/Admin/{fhirId}/Specialities';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminFhirIdSpecialitiesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminFhirIdSpecialitiesGet$Response(params: ApiAdminFhirIdSpecialitiesGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<KeyValueModel>>> {
    return apiAdminFhirIdSpecialitiesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminFhirIdSpecialitiesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminFhirIdSpecialitiesGet(params: ApiAdminFhirIdSpecialitiesGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.apiAdminFhirIdSpecialitiesGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `apiAdminFhirIdParentOrganizationSpecialitiesGet()` */
  static readonly ApiAdminFhirIdParentOrganizationSpecialitiesGetPath = '/api/Admin/{fhirId}/ParentOrganizationSpecialities';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminFhirIdParentOrganizationSpecialitiesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminFhirIdParentOrganizationSpecialitiesGet$Response(params: ApiAdminFhirIdParentOrganizationSpecialitiesGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<KeyValueModel>>> {
    return apiAdminFhirIdParentOrganizationSpecialitiesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminFhirIdParentOrganizationSpecialitiesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminFhirIdParentOrganizationSpecialitiesGet(params: ApiAdminFhirIdParentOrganizationSpecialitiesGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.apiAdminFhirIdParentOrganizationSpecialitiesGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `apiAdminPractitionerIdPasswordResetPost()` */
  static readonly ApiAdminPractitionerIdPasswordResetPostPath = '/api/Admin/{practitionerId}/PasswordReset';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminPractitionerIdPasswordResetPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminPractitionerIdPasswordResetPost$Response(params: ApiAdminPractitionerIdPasswordResetPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<void>> {
    return apiAdminPractitionerIdPasswordResetPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminPractitionerIdPasswordResetPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminPractitionerIdPasswordResetPost(params: ApiAdminPractitionerIdPasswordResetPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAdminPractitionerIdPasswordResetPost$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAdminSystemSpecialityGroupsGet()` */
  static readonly ApiAdminSystemSpecialityGroupsGetPath = '/api/Admin/system-speciality-groups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminSystemSpecialityGroupsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminSystemSpecialityGroupsGet$Response(params?: ApiAdminSystemSpecialityGroupsGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<void>> {
    return apiAdminSystemSpecialityGroupsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminSystemSpecialityGroupsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminSystemSpecialityGroupsGet(params?: ApiAdminSystemSpecialityGroupsGet$Params, context?: HttpContext): Observable<void> {
    return this.apiAdminSystemSpecialityGroupsGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAdminSystemSpecialityGroupsPost()` */
  static readonly ApiAdminSystemSpecialityGroupsPostPath = '/api/Admin/system-speciality-groups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminSystemSpecialityGroupsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminSystemSpecialityGroupsPost$Response(params?: ApiAdminSystemSpecialityGroupsPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<SystemSpecialityGroupViewModel>> {
    return apiAdminSystemSpecialityGroupsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminSystemSpecialityGroupsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminSystemSpecialityGroupsPost(params?: ApiAdminSystemSpecialityGroupsPost$Params, context?: HttpContext): Observable<SystemSpecialityGroupViewModel> {
    return this.apiAdminSystemSpecialityGroupsPost$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<SystemSpecialityGroupViewModel>): SystemSpecialityGroupViewModel => r.body)
    );
  }

  /** Path part for operation `apiAdminSystemSpecialityGroupsIdGet()` */
  static readonly ApiAdminSystemSpecialityGroupsIdGetPath = '/api/Admin/system-speciality-groups/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminSystemSpecialityGroupsIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminSystemSpecialityGroupsIdGet$Response(params: ApiAdminSystemSpecialityGroupsIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<SystemSpecialityGroupViewModel>> {
    return apiAdminSystemSpecialityGroupsIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminSystemSpecialityGroupsIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminSystemSpecialityGroupsIdGet(params: ApiAdminSystemSpecialityGroupsIdGet$Params, context?: HttpContext): Observable<SystemSpecialityGroupViewModel> {
    return this.apiAdminSystemSpecialityGroupsIdGet$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<SystemSpecialityGroupViewModel>): SystemSpecialityGroupViewModel => r.body)
    );
  }

  /** Path part for operation `apiAdminSystemSpecialityGroupsIdPut()` */
  static readonly ApiAdminSystemSpecialityGroupsIdPutPath = '/api/Admin/system-speciality-groups/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminSystemSpecialityGroupsIdPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminSystemSpecialityGroupsIdPut$Response(params: ApiAdminSystemSpecialityGroupsIdPut$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<SystemSpecialityGroupViewModel>> {
    return apiAdminSystemSpecialityGroupsIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminSystemSpecialityGroupsIdPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminSystemSpecialityGroupsIdPut(params: ApiAdminSystemSpecialityGroupsIdPut$Params, context?: HttpContext): Observable<SystemSpecialityGroupViewModel> {
    return this.apiAdminSystemSpecialityGroupsIdPut$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<SystemSpecialityGroupViewModel>): SystemSpecialityGroupViewModel => r.body)
    );
  }

  /** Path part for operation `apiAdminSystemSpecialityGroupsIdDelete()` */
  static readonly ApiAdminSystemSpecialityGroupsIdDeletePath = '/api/Admin/system-speciality-groups/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminSystemSpecialityGroupsIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminSystemSpecialityGroupsIdDelete$Response(params: ApiAdminSystemSpecialityGroupsIdDelete$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<void>> {
    return apiAdminSystemSpecialityGroupsIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminSystemSpecialityGroupsIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAdminSystemSpecialityGroupsIdDelete(params: ApiAdminSystemSpecialityGroupsIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.apiAdminSystemSpecialityGroupsIdDelete$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAdminSystemSpecialityGroupsIdMappingsPost()` */
  static readonly ApiAdminSystemSpecialityGroupsIdMappingsPostPath = '/api/Admin/system-speciality-groups/{id}/mappings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAdminSystemSpecialityGroupsIdMappingsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminSystemSpecialityGroupsIdMappingsPost$Response(params: ApiAdminSystemSpecialityGroupsIdMappingsPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<void>> {
    return apiAdminSystemSpecialityGroupsIdMappingsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAdminSystemSpecialityGroupsIdMappingsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAdminSystemSpecialityGroupsIdMappingsPost(params: ApiAdminSystemSpecialityGroupsIdMappingsPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAdminSystemSpecialityGroupsIdMappingsPost$Response(params, context).pipe(
      map((r: HealthFindrStrictHttpResponse<void>): void => r.body)
    );
  }

}
